import { BusinessAdmin } from '../../pages';
import React, { useState } from 'react';
import { toJS } from 'mobx';
import { employeeStore } from '../../stores';

const BusinessAdminContainer = () => {
	const [addAdmin, setAddAdmin] = useState(false);
	const [editAdmin, setEditAdmin] = useState(false);

	const goToAddAdmin = () => {
		setAddAdmin(true);
	};

	const goToEditAdmin = () => {
		setEditAdmin(true);
	};

	const closeModal = () => {
		setAddAdmin(false);
		setEditAdmin(false);
	};
	return (
		<BusinessAdmin
			addAdmin={addAdmin}
			businessAdmins= {toJS(employeeStore.businessAdmins)}
			goToAddAdmin={goToAddAdmin}
			closeModal={closeModal}
			editAdmin={editAdmin}
			goToEditAdmin={goToEditAdmin}
		/>
	);
};

export default BusinessAdminContainer;
